import { forEachObjIndexed } from 'ramda';

import type { Prospect } from '../containers/ProspectProfile/types';
import type { FilterValue, OrderValue } from '../containers/App/types';
import { patch, post, put, apiURL } from '../utils/api';
import { getCookie } from '../utils/cookie';

import request from '../utils/api';
class ProspectProfileService {
  save(prospect: Prospect, organizationId: string) {
    const options = {
      method: 'POST',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(prospect),
    };
    return request(
      `${apiURL}/${organizationId}/${prospect.propertyId}/prospects`,
      options,
    );
  }
  update(prospect: Prospect, organizationId: string) {
    const id = prospect.id || '';
    const options = {
      method: 'PUT',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(prospect),
    };
    return request(
      `${apiURL}/${organizationId}/${prospect.propertyId}/prospects/${id}`,
      options,
    );
  }

  assign(prospect: Prospect, organizationId: string) {
    const id = prospect.id || '';

    const body = JSON.stringify({
      id: prospect.id,
      assignedToId: prospect.assignedToId,
      propertyId: prospect.propertyId,
    });

    return put(
      `/${organizationId}/${prospect.propertyId}/prospects/${id}/assignee`,
      body,
    );
  }
  convertToApplicant(
    organizationId: string,
    propertyId: string,
    prospectId: string,
    payload: Object,
  ) {
    return post(
      `/${organizationId}/${propertyId}/prospects/${prospectId}/convert-to-applicant`,
      JSON.stringify(payload),
    );
  }

  updateDesiredMoveInDate(
    organizationId: string,
    propertyId: string,
    prospectId: string,
    payload: { moveInDateFrom: string },
  ) {
    return patch(
      `/${organizationId}/${propertyId}/prospects/${prospectId}/desired-move-in-date`,
      JSON.stringify(payload),
    );
  }

  changeStatus(
    prospect: Prospect,
    prospectStatusId: string,
    notes: string,
    organizationId: string,
  ) {
    const id = prospect.id || '';
    const options = {
      method: 'PUT',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        prospectStatusId,
        notes,
      }),
    };
    return request(
      `${apiURL}/${organizationId}/${prospect.propertyId}/prospects/${id}/status`,
      options,
    );
  }
  getAllProspects({ organizationId, propertyId, getAllStatuses = false }) {
    const options = {
      method: 'GET',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };

    const urlSearchParams = new URLSearchParams({
      pagination: false,
      getAllStatuses,
    });

    return request(
      `${apiURL}/${organizationId}/${propertyId}/prospects?${urlSearchParams}`,
      options,
    );
  }
  getAll(
    pageNumber: number,
    limit: number,
    filterValue: FilterValue,
    sorting: OrderValue,
    searchText: string,
    propertyId: string,
    organizationId: string,
  ) {
    const options = {
      method: 'GET',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    const filters: Array<string> = [];
    forEachObjIndexed((valueFilter, keyFilter) => {
      forEachObjIndexed((valueOption, keyOption) => {
        if (valueOption) {
          filters.push(`${keyFilter}=${keyOption}`);
        }
      }, valueFilter);
    }, filterValue);
    const sort =
      sorting.fieldName === ''
        ? ''
        : `&sort=${sorting.fieldName}&order=${sorting.order}`;
    const query = searchText === '' ? '' : `&query=${searchText}`;
    const queryString = `page=${pageNumber}&limit=${limit}${query}${sort}&${filters.join(
      '&',
    )}`;
    return request(
      `${apiURL}/${organizationId}/${propertyId}/prospects?${queryString}`,
      options,
    );
  }
  getOne(prospectId: string, propertyId: string, organizationId: string) {
    const id = prospectId;
    const options = {
      method: 'GET',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(
      `${apiURL}/${organizationId}/${propertyId}/prospects/${id}`,
      options,
    );
  }
  getByPhoneNumber(
    phoneNumber: string,
    propertyId: string,
    organizationId: string,
  ) {
    const options = {
      method: 'GET',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    const queryString = `query=${phoneNumber}`;
    return request(
      `${apiURL}/${organizationId}/${propertyId}/prospects?${queryString}`,
      options,
    );
  }

  getNextActivitiesByProspectIds(
    organizationId: string,
    propertyId: string,
    prospectIds: Array<string>,
  ) {
    const options = {
      method: 'POST',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ prospectIds }),
    };

    return request(
      `${apiURL}/${organizationId}/${propertyId}/prospects/next-activities`,
      options,
    );
  }
}

export default ProspectProfileService;
